import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/session-callback", { session_id: sessionId });
        setUser(data);
        // Clean hash and navigate
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/library", { replace: true, state: { user: data } });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center paper-bg" data-testid="auth-callback-screen">
      <div className="text-center">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D35230] mb-3">Tuning frequency</p>
        <p className="font-serif-display text-3xl">Connecting to Recho Music…</p>
      </div>
    </div>
  );
}
